import { Dispatch, SetStateAction, useState } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import { TimezoneSelectorModal, TimezoneSelectorModalProps } from './modals'
import { Button, DateRangePicker, Icon, Space, Text } from '../common'
import { colors } from 'lib/colors'

export interface BookingDatetimeSelectProps
  extends Omit<TimezoneSelectorModalProps, 'onOk'> {
  date?: [moment.Moment, moment.Moment]
  timezone: [moment.Moment, moment.Moment]
  inactive: boolean
  loading: boolean
  rateDefaultTitle?: string
  onDateChange: Dispatch<SetStateAction<[moment.Moment, moment.Moment]>>
  onTimezoneChange: Dispatch<SetStateAction<[moment.Moment, moment.Moment]>>
}

export const BookingDatetimeSelect = ({
  date,
  timezone,
  dataSource,
  onDateChange,
  onTimezoneChange,
  loading,
  error,
  rateId,
  rateDefaultTitle,
  inactive,
  checkManualPeriodTime,
  setManualPeriodTime,
  setRateVariantId,
  ...rest
}: BookingDatetimeSelectProps): JSX.Element => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [category, setCategory] = useState<string>(null)
  const handleSelect = (
    value: [moment.Moment, moment.Moment],
    category?: string
  ) => {
    onTimezoneChange(value)
    setCategory(category)
    setIsVisible(false)
  }

  const handleDisable = (): boolean => {
    if (loading) return true
    else return inactive
  }

  return (
    <Space direction="vertical" size="middle">
      <div>
        <div className="mb-1">
          <Text strong>利用予定日</Text>
        </div>
        <DateRangePicker
          picker="date"
          value={date}
          onChange={(dates) => {
            // Even the return type is [moment.Moment, moment.Moment], its giving Type error
            // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onDateChange(dates)
          }}
          disabled={inactive}
          style={{ backgroundColor: '#FFFFFF' }}
        />
      </div>
      <div>
        <div className="mb-1">
          <Text strong>利用時間帯</Text>
        </div>
        <Button
          className={clsx('mr-4')}
          onClick={() => setIsVisible(true)}
          icon={<Icon.CalendarTwoTone twoToneColor={colors.FUJI} />}
          disabled={handleDisable()}
          loading={loading}
          style={{ backgroundColor: '#FFFFFF' }}
        >
          {timezone
            ? `${timezone[0].format('HH:mm')} - ${timezone[1].format('HH:mm')}`
            : '時間帯を選択'}
          {(category || rateDefaultTitle) &&
            `（${category || rateDefaultTitle}）`}
        </Button>
        {!timezone && <Text strong>予約時間帯を選択してください</Text>}
      </div>
      <TimezoneSelectorModal
        visible={isVisible}
        dataSource={dataSource}
        onOk={handleSelect}
        error={error}
        onCancel={() => setIsVisible(false)}
        rateId={rateId}
        checkManualPeriodTime={checkManualPeriodTime}
        setManualPeriodTime={setManualPeriodTime}
        setRateVariantId={setRateVariantId}
      />
    </Space>
  )
}
